/* ============================================================
   GLTRverse Shopify Theme — theme.js
   Vanilla JS. AJAX cart drawer, header scroll state,
   mood-picker, before/after slider, quantity steppers.
   ============================================================ */
(function () {
  'use strict';

  var money = function (cents) {
    if (window.Shopify && Shopify.formatMoney && window.GLTR_MONEY_FORMAT) {
      return Shopify.formatMoney(cents, window.GLTR_MONEY_FORMAT);
    }
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  };

  /* ---------- header scroll state ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 24) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- cart drawer ---------- */
  var drawer = document.querySelector('.cart-drawer');
  var scrim = document.querySelector('.cart-scrim');
  var drawerEnabled = document.body.getAttribute('data-cart-drawer') !== 'false';

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (scrim) scrim.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    if (!drawer) return;
    var itemsEl = drawer.querySelector('.cart-drawer__items');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    var countEls = document.querySelectorAll('[data-cart-count]');

    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });

    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    var checkoutBtn = drawer.querySelector('[data-checkout]');
    if (checkoutBtn) {
      checkoutBtn.disabled = cart.item_count === 0;
    }

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="cart-empty">' +
        '<p class="cart-empty__title">' + (drawer.getAttribute('data-empty') || "The hour hasn't started.") + '</p>' +
        '<p class="cart-empty__sub">' + (drawer.getAttribute('data-empty-sub') || '') + '</p>' +
        '</div>';
      return;
    }

    var html = '';
    cart.items.forEach(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1') : '';
      html +=
        '<div class="cart-item" data-line="' + (i + 1) + '">' +
          '<a href="' + item.url + '" class="cart-item__img" style="background-image:url(\'' + img + '\')"></a>' +
          '<div>' +
            '<h4 class="cart-item__name"><a href="' + item.url + '">' + item.product_title + '</a></h4>' +
            '<div class="cart-item__meta">' + (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '') + '</div>' +
            '<div class="cart-item__qty">' +
              '<button type="button" data-qty-down aria-label="Decrease">\u2212</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-up aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="cart-item__price">' + money(item.final_line_price) + '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(form) {
    var formData = new FormData(form);
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        if (drawerEnabled) openDrawer();
        else window.location.href = '/cart';
        return cart;
      })
      .finally(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
      });
  }

  /* open cart triggers */
  document.addEventListener('click', function (e) {
    var openEl = e.target.closest('[data-cart-open]');
    if (openEl) {
      e.preventDefault();
      if (drawerEnabled) { openDrawer(); fetchCart(); }
      else window.location.href = '/cart';
      return;
    }
    if (e.target.closest('[data-cart-close]') || e.target === scrim) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    /* qty steppers inside drawer */
    var up = e.target.closest('[data-qty-up]');
    var down = e.target.closest('[data-qty-down]');
    if (up || down) {
      var row = e.target.closest('[data-line]');
      if (!row) return;
      var line = parseInt(row.getAttribute('data-line'), 10);
      var span = row.querySelector('.cart-item__qty span');
      var current = parseInt(span.textContent, 10);
      var next = up ? current + 1 : current - 1;
      changeLine(line, Math.max(0, next));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* product add-to-cart forms (AJAX) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form');
    if (!form) return;
    var action = form.getAttribute('action') || '';
    var isAdd = action.indexOf('/cart/add') !== -1
      || form.querySelector('input[name="form_type"][value="product"]')
      || form.hasAttribute('data-ajax-cart');
    if (!isAdd) return;
    if (!drawerEnabled) return; /* fall back to native POST → /cart */
    e.preventDefault();
    addToCart(form);
  });

  /* PDP quantity stepper (pre-add) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pdp-qty]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty-wrap]');
    if (!wrap) return;
    var input = wrap.querySelector('input[name="quantity"]');
    var val = parseInt(input.value, 10) || 1;
    val = btn.getAttribute('data-pdp-qty') === 'up' ? val + 1 : Math.max(1, val - 1);
    input.value = val;
    var priceEl = document.querySelector('[data-dynamic-price]');
    if (priceEl && priceEl.getAttribute('data-unit')) {
      var unit = parseInt(priceEl.getAttribute('data-unit'), 10);
      priceEl.textContent = money(unit * val);
    }
  });

  /* PDP gallery thumbs */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    if (main) {
      var mainImg = main.querySelector('[data-gallery-img]');
      var src = thumb.getAttribute('data-img');
      if (mainImg) { mainImg.src = src; mainImg.srcset = ''; }
      else { main.style.backgroundImage = "url('" + src + "')"; }
    }
  });

  /* ---------- mood picker ---------- */
  document.querySelectorAll('[data-mood-picker]').forEach(function (mp) {
    var range = mp.querySelector('input[type="range"]');
    if (!range) return;
    var fill = mp.querySelector('.mood-picker__rail-fill');
    var thumb = mp.querySelector('.mood-picker__thumb');
    var heading = mp.querySelector('.mood-picker__sub');
    var timeEl = mp.querySelector('.mood-picker__time');
    var verdictBtn = mp.querySelector('[data-mood-cta]');
    var bottles = mp.querySelectorAll('.mood-picker__bottle');

    var products = window.GLTR_MOOD_PRODUCTS || [];
    var captions = (window.GLTR_MOOD_CONFIG && window.GLTR_MOOD_CONFIG.captions) || [
      { max: 32, line: "The light is still warm. Skin's about to follow.", title: 'Halo finds you.', time: '6:14 PM' },
      { max: 66, line: "The hour the light goes amber. Honey on the shoulders.", title: 'Amber finds you.', time: '9:30 PM' },
      { max: 101, line: "The hour that has no number. Violet where the light moves.", title: 'Stardust finds you.', time: '12:38 AM' }
    ];

    function lerp(a, b, k) { return a + (b - a) * k; }
    function lerpRGB(c1, c2, k) {
      return 'rgb(' + Math.round(lerp(c1[0], c2[0], k)) + ',' + Math.round(lerp(c1[1], c2[1], k)) + ',' + Math.round(lerp(c1[2], c2[2], k)) + ')';
    }

    function update() {
      var t = parseInt(range.value, 10);
      var k = t / 100;
      var bg;
      if (k < 0.5) bg = lerpRGB([244, 240, 232], [244, 226, 220], k / 0.5);
      else bg = lerpRGB([244, 226, 220], [45, 26, 54], (k - 0.5) / 0.5);
      mp.style.background = bg;

      var inkLight = k > 0.78;
      mp.style.color = inkLight ? 'var(--pearl-light)' : 'var(--ink)';
      mp.classList.toggle('mood-picker--night', k > 0.66);

      if (fill) fill.style.width = t + '%';
      if (thumb) thumb.style.left = t + '%';

      var cap = captions.find(function (c) { return t < c.max; }) || captions[2];
      if (heading) heading.textContent = cap.line;

      if (timeEl && cap.time) timeEl.textContent = cap.time;

      bottles.forEach(function (b) {
        var slug = b.getAttribute('data-slug');
        var op = 0;
        if (slug === 'halo') op = t < 32 ? 1 : Math.max(0, 1 - (t - 32) / 14);
        if (slug === 'amber') op = t < 32 ? Math.max(0, (t - 18) / 14) : t < 66 ? 1 : Math.max(0, 1 - (t - 66) / 14);
        if (slug === 'stardust') op = t < 66 ? Math.max(0, (t - 52) / 14) : 1;
        b.style.opacity = op;
      });

      var choice = t < 32 ? products[0] : t < 66 ? products[1] : products[2];
      if (verdictBtn) {
        verdictBtn.textContent = cap.title + ' \u2192';
        if (cap.url) verdictBtn.setAttribute('href', cap.url);
      }
    }
    range.addEventListener('input', update);
    update();
  });

  /* ---------- before / after slider ---------- */
  document.querySelectorAll('[data-before-after]').forEach(function (ba) {
    var handle = ba.querySelector('.before-after__handle');
    var after = ba.querySelector('.before-after__layer--after');
    var dragging = false;
    function setPos(clientX) {
      var r = ba.getBoundingClientRect();
      var p = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
      ba.style.setProperty('--ba-pos', p + '%');
      if (after) after.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
    }
    var down = function (e) { dragging = true; setPos((e.touches ? e.touches[0] : e).clientX); };
    var move = function (e) { if (dragging) setPos((e.touches ? e.touches[0] : e).clientX); };
    var up = function () { dragging = false; };
    ba.addEventListener('mousedown', down);
    ba.addEventListener('touchstart', down, { passive: true });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', up);
    window.addEventListener('touchend', up);
    setPos(ba.getBoundingClientRect().left + ba.getBoundingClientRect().width / 2);
  });

  /* initial cart hydrate (counts) */
  if (document.querySelector('[data-cart-count]')) fetchCart();
})();

/* ---- mobile nav toggle ---- */
(function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var closeEls = document.querySelectorAll('[data-nav-close]');
  if (!toggle) return;
  function close() {
    document.body.classList.remove('nav-open');
    toggle.setAttribute('aria-expanded', 'false');
  }
  toggle.addEventListener('click', function () {
    var open = document.body.classList.toggle('nav-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  for (var i = 0; i < closeEls.length; i++) closeEls[i].addEventListener('click', close);
  var nav = document.querySelector('[data-nav]');
  if (nav) {
    var links = nav.querySelectorAll('a');
    for (var j = 0; j < links.length; j++) links[j].addEventListener('click', close);
  }
})();

/* ---- hero multi-image crossfade ---- */
(function () {
  var wrap = document.querySelector('[data-hero-slides]');
  if (!wrap) return;
  var slides = wrap.querySelectorAll('.hero__slide');
  if (slides.length < 2) return;
  var i = 0;
  setInterval(function () {
    slides[i].classList.remove('is-active');
    i = (i + 1) % slides.length;
    slides[i].classList.add('is-active');
  }, 5000);
})();
/* ===== v2: scroll reveal animations ===== */
(function () {
  var els = document.querySelectorAll('.reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-visible');
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  for (var j = 0; j < els.length; j++) io.observe(els[j]);
})();

/* ===== ritual numbers: animate when the row itself is reached ===== */
(function () {
  var rows = document.querySelectorAll('.ritual');
  if (!rows.length) return;
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
    for (var i = 0; i < rows.length; i++) rows[i].classList.add('nums-in');
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    for (var k = 0; k < entries.length; k++) {
      if (entries[k].isIntersecting) { entries[k].target.classList.add('nums-in'); io.unobserve(entries[k].target); }
    }
  }, { threshold: 0.3 });
  for (var j = 0; j < rows.length; j++) io.observe(rows[j]);
})();

/* ===== v2: subscribe popup ===== */
(function () {
  var pop = document.querySelector('[data-popup]');
  if (!pop) return;
  var KEY = 'gltr_popup_dismissed';
  var dismissed;
  try { dismissed = localStorage.getItem(KEY); } catch (e) { dismissed = null; }
  if (dismissed) return;
  var delay = (parseInt(pop.getAttribute('data-popup-delay'), 10) || 3) * 1000;
  function open() { pop.classList.add('is-open'); }
  function close() {
    pop.classList.remove('is-open');
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
  }
  var t = setTimeout(open, delay);
  pop.addEventListener('click', function (e) {
    if (e.target === pop || e.target.closest('[data-popup-close]')) { clearTimeout(t); close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });
  // keep open on successful signup so the code is visible (success markup present)
  var success = pop.querySelector('.gltr-popup__success');
  if (success) { clearTimeout(t); open(); }
  // tap-to-copy the discount code
  var copyBtn = pop.querySelector('[data-copy-code]');
  var codeEl = pop.querySelector('[data-code]');
  if (copyBtn && codeEl) {
    copyBtn.addEventListener('click', function () {
      var code = (codeEl.textContent || '').trim();
      var done = function () { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Tap to copy'; }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        var r = document.createRange(); r.selectNode(codeEl);
        var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
        try { document.execCommand('copy'); } catch (e) {}
        sel.removeAllRanges(); done();
      }
    });
  }
})();

/* ===== v2.1: add-to-cart sparkle burst ===== */
(function () {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var STAR = '<svg viewBox="0 0 24 24"><path d="M12 0c.6 5.7 5.7 10.8 11.4 11.4C17.7 12 12.6 17.1 12 24c-.6-6.9-5.7-12-11.4-12.6C6.3 10.8 11.4 5.7 12 0z"/></svg>';
  function burst(x, y) {
    var n = 12;
    for (var i = 0; i < n; i++) {
      var sp = document.createElement('div');
      sp.className = 'gltr-spark';
      sp.innerHTML = STAR;
      var ang = (Math.PI * 2 * i) / n + Math.random() * 0.6;
      var dist = 26 + Math.random() * 42;
      sp.style.left = x + 'px';
      sp.style.top = y + 'px';
      sp.style.setProperty('--dx', Math.cos(ang) * dist + 'px');
      sp.style.setProperty('--dy', Math.sin(ang) * dist + 'px');
      sp.style.setProperty('--rot', (Math.random() * 220 - 110) + 'deg');
      var size = 6 + Math.random() * 8;
      sp.style.width = size + 'px';
      sp.style.height = size + 'px';
      sp.style.animation = 'gltr-spark-fly ' + (700 + Math.random() * 400) + 'ms cubic-bezier(.16,.7,.3,1) forwards';
      document.body.appendChild(sp);
      (function (el) { setTimeout(function () { el.remove(); }, 1300); })(sp);
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[type="submit"], [data-add-to-cart]');
    if (!btn) return;
    var form = btn.closest('form[action$="/cart/add"], form[data-ajax-cart]');
    if (!form && !btn.matches('[data-add-to-cart]')) return;
    var r = btn.getBoundingClientRect();
    burst(r.left + r.width / 2, r.top + r.height / 2);
    if (!btn.classList.contains('gltr-glow')) {
      btn.classList.add('gltr-glow');
      (function (b) { setTimeout(function () { b.classList.remove('gltr-glow'); }, 1000); })(btn);
    }
  }, true);
})();

/* ===== count-up numbers on scroll-in ===== */
(function () {
  var els = document.querySelectorAll('[data-countup]');
  if (!els.length) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function run(el) {
    var target = parseInt(el.getAttribute('data-countup'), 10);
    if (isNaN(target)) return;
    if (reduce) { el.textContent = target; return; }
    var dur = 1100, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(eased * target);
      if (p < 1) requestAnimationFrame(step); else el.textContent = target;
    }
    requestAnimationFrame(step);
  }
  if (!('IntersectionObserver' in window)) { for (var i = 0; i < els.length; i++) run(els[i]); return; }
  var io = new IntersectionObserver(function (entries) {
    for (var k = 0; k < entries.length; k++) {
      if (entries[k].isIntersecting) { run(entries[k].target); io.unobserve(entries[k].target); }
    }
  }, { threshold: 0.6 });
  for (var j = 0; j < els.length; j++) io.observe(els[j]);
})();

/* ===== v2.1: scroll parallax ===== */
(function () {
  var nodes = document.querySelectorAll('[data-parallax]');
  if (!nodes.length || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var items = [];
  for (var i = 0; i < nodes.length; i++) {
    var bg = nodes[i].querySelector('[data-parallax-bg]');
    if (bg) items.push({ host: nodes[i], bg: bg });
  }
  var ticking = false;
  function update() {
    var vh = window.innerHeight;
    for (var k = 0; k < items.length; k++) {
      var rect = items[k].host.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) continue;
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh; // -0.5..0.5 ish
      var shift = progress * -260; // px
      items[k].bg.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
    }
    ticking = false;
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
